import { useEffect, useState } from 'react';

function calculateTimeLeft(targetDate) {
  const difference = new Date(targetDate).getTime() - Date.now();

  if (difference <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / (1000 * 60)) % 60),
    seconds: Math.floor((difference / 1000) % 60),
  };
}

export default function CountdownBadge({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState(() =>
    calculateTimeLeft(targetDate)
  );

  useEffect(() => {
    const updateCountdown = () => {
      setTimeLeft(calculateTimeLeft(targetDate));
    };

    updateCountdown();

    const interval = window.setInterval(updateCountdown, 1000);

    return () => window.clearInterval(interval);
  }, [targetDate]);

  const units = [
    { value: timeLeft.days, label: 'd' },
    { value: timeLeft.hours, label: 'h' },
    { value: timeLeft.minutes, label: 'm' },
    { value: timeLeft.seconds, label: 's' },
  ];

  return (
    <div className="hero-countdown" aria-label="Countdown to EAC2027">
      <span className="hero-countdown-label">Starting in</span>

      <div className="hero-countdown-values">
        {units.map((unit, index) => (
          <span className="hero-countdown-item" key={unit.label}>
            <span className="hero-countdown-unit">
              <strong>{String(unit.value).padStart(2, '0')}</strong>
              <span>{unit.label}</span>
            </span>

            {index < units.length - 1 && (
              <span className="hero-countdown-separator" aria-hidden="true">
                :
              </span>
            )}
          </span>
        ))}
      </div>
      
    </div>
  );
}